<template>
  <ContainerWrapper>
    <OffersList v-if="cptdDisplayAffiliates" title="Consignado">
      <PicPayInssOfferCardContainer
        v-if="cptdDisplayPicPayInss"
        key="PICPAY_INSS"
      />
      <PicPaySiapeOfferCardContainer
        v-if="cptdDisplayPicPaySiape"
        key="PICPAY_SIAPE"
      />
    </OffersList>
  </ContainerWrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import { IncomeSource } from '@/data/common'
import { checkAge } from '@/helpers/date'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import OffersList from '@/components/appForm/loanResults/OffersList.vue'
import PicPayInssOfferCardContainer from '@/containers/loans/payroll/offer/affiliates/picpay/PicPayInssOfferCardContainer.vue'
import PicPaySiapeOfferCardContainer from '@/containers/loans/payroll/offer/affiliates/picpay/PicPaySiapeOfferCardContainer.vue'
export default {
  name: 'PayrollOffersListContainer',
  components: {
    PicPaySiapeOfferCardContainer,
    PicPayInssOfferCardContainer,
    ContainerWrapper,
    OffersList,
  },
  computed: {
    ...mapGetters({
      personaData: 'user/persona/personaData',
    }),
    cptdDisplayAffiliates() {
      return this.cptdDisplayPicPayInss || this.cptdDisplayPicPaySiape
    },
    cptdDisplayPicPayInss() {
      return (
        checkAge(18, 78, this.personaData?.info?.birth_date) &&
        [IncomeSource.PENSION, IncomeSource.RETIREMENT].includes(
          this.personaData?.finance?.income_source ?? '',
        )
      )
    },
    cptdDisplayPicPaySiape() {
      return false
      // return (
      //   checkAge(18, 70, this.personaData?.info?.birth_date) &&
      //   [IncomeSource.FEDERAL_WORKER, IncomeSource.MILITARY].includes(
      //     this.personaData?.finance?.income_source ?? ''
      //   )
      // )
    },
  },
}
</script>
<style lang="scss"></style>
